import PropTypes from 'prop-types';
import React from 'react';
import { LocaleService } from '@sm360/widget-commons-core-services';

/* eslint-disable react/no-danger */

const VehicleTitle = ({ packageName, vehicleStockNo, title, vehicleVinNo }) => {
    const currentPackage = packageName !== '' && (
        <p
            className="current-package"
            dangerouslySetInnerHTML={{
                __html: packageName,
            }}
        />
    );
    const stockNo = vehicleStockNo &&
        vehicleStockNo !== '' && (
            <p className="vehicle-stockno">
                {LocaleService.t('SUMMARY.STOCK_NUMBER', {
                    stock: vehicleStockNo,
                })}
            </p>
        );

    const vinNo = vehicleVinNo &&
        vehicleVinNo !== '' && (
            <p className="vehicle-vinno">
                {LocaleService.t('SUMMARY.VIN_NUMBER', {
                    vin: vehicleVinNo,
                })}
            </p>
        );

    return (
        <div className="vehicle-overview__vehicle-title">
            <h3 className="trim is-bold" dangerouslySetInnerHTML={{ __html: title }} />
            {currentPackage}
            {vinNo}
            {stockNo}
        </div>
    );
};

VehicleTitle.defaultProps = {
    packageName: '',
    vehicleStockNo: '',
    vehicleVinNo: '',
};

VehicleTitle.propTypes = {
    packageName: PropTypes.string,
    vehicleStockNo: PropTypes.string,
    title: PropTypes.string.isRequired,
    vehicleVinNo: PropTypes.string,
};

VehicleTitle.displayName = 'VehicleTitle';

export default VehicleTitle;
